/*
 * Package: WebVideo.FormFilter
 * Version: $Id$
 * Copyright (c) 2012 Sergey Leonov
 */

function FormFilter() {}

FormFilter.changeTimePeriod = function(form_wrapper, index) {
  var form = jQuery(form_wrapper).parents("form"),
      filter_from = "",
      filter_to = "",
      now = new Date();
  //today
  if (index == "today") {
    filter_from = jQuery.format.date(now, Config.dateFormat);
    filter_to = filter_from;
  }
  //yesterday
  else if (index == "yesterday") {
    filter_from = jQuery.format.date(new Date(now.getFullYear(), now.getMonth(), now.getDate()-1), Config.dateFormat);
    filter_to = filter_from;
  }
  //thismonth
  else if (index == "thismonth") {
    filter_from = jQuery.format.date(new Date(now.getFullYear(), now.getMonth(), 1), Config.dateFormat);
    filter_to = jQuery.format.date(new Date(now.getFullYear(), now.getMonth()+1, 0), Config.dateFormat);
  }
  //lastmonth
  else if (index == "lastmonth") {
    filter_from = jQuery.format.date(new Date(now.getFullYear(), now.getMonth()-1, 1), Config.dateFormat);
    filter_to = jQuery.format.date(new Date(now.getFullYear(), now.getMonth(), 0), Config.dateFormat);
  }
  //thisyear
  else if (index == "thisyear") {
    filter_from = jQuery.format.date(new Date(now.getFullYear(), 0, 1), Config.dateFormat);
    filter_to = jQuery.format.date(new Date(now.getFullYear()+1, 0, 0), Config.dateFormat);
  }
  //lastyear
  else if (index == "lastyear") {
    filter_from = jQuery.format.date(new Date(now.getFullYear()-1, 0, 1), Config.dateFormat);
    filter_to = jQuery.format.date(new Date(now.getFullYear(), 0, 0), Config.dateFormat);
  }
  //alltime
  else if (index == "alltime") {
    filter_from = "";
    filter_to = filter_from;
  }
  //


  var inputs = jQuery(form).find("input.time-filter");
  if (inputs.length == 0) inputs = jQuery(form).find("input.calendar-input");

  inputs.each(function() { 
    var inp = jQuery(this);
    var name = inp.attr("name");
    //filter from
    if (name.indexOf("_from") != -1) {
      inp.val(filter_from);
    }
    //filter to
    if (name.indexOf("_to") != -1) {
      inp.val(filter_to);
    }    
  });
  //submit
  form.submit();
};